import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import * as userInfoActions from '../actions/userInfoActions';

import A from '../components/demo/A';
import B from '../components/demo/B';
import C from '../components/demo/C';

class Hello extends React.Component{

    render(){

        return(
            <div>
                <p>Hello world</p>
                <hr/>
                <A userInfo={this.props.userInfo}/>
                <hr/>
                <B userInfo={this.props.userInfo}/>
                <hr/>
                <C actions={this.props.userInfoActions}/>
            </div>
        )
    }

    componentDidMount(){
        this.props.userInfoActions.login({
            userId:'abc',
            city:'beijing'
        })
    }
}

function mapStateToProps(state) {
    return {
        userInfo: state.userInfo
    }
}

function mapDispatchToProps(dispatch) {
    return {
        userInfoActions: bindActionCreators(userInfoActions, dispatch)
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Hello)



// WEBPACK FOOTER //
// ./src/containers/Hello.js